import React from 'react'
import IconBan from 'front-end/src/components/common/icon/IconBan'
import { Trans } from '@lingui/macro'
import { Box } from 'front-end/src/components'

export const OrganisationSuspendedError = () => (
  <Box className="Auth__noAccess">
    <IconBan />
    <h2>
      <Trans>The Looop platform is no longer in use please contact your LMS admin for further details</Trans>
    </h2>
  </Box>
)
